// extracted by mini-css-extract-plugin
export default {"info":"Info_info__cYr-A","title":"Info_title__lSdqC","link":"Info_link__2OwQX"};